export const ENVIRONMENTS = {
  QA: 'qa',
  DEV: 'dev',
  LOCAL: 'localhost',
  PROD: 'prod',
};

/**
 * Get the current environment based on VUE_APP_API_BASE_URL
 */
export const getCurrentEnvironment = () => {
  const apiUrl = process.env.VUE_APP_API_BASE_URL;

  if (!apiUrl) {
    console.warn('VUE_APP_API_BASE_URL is not defined, defaulting to PROD environment');
    return ENVIRONMENTS.PROD;
  }

  if (apiUrl.includes(ENVIRONMENTS.QA)) return ENVIRONMENTS.QA;
  if (apiUrl.includes(ENVIRONMENTS.DEV) || apiUrl.includes(ENVIRONMENTS.LOCAL))
    return ENVIRONMENTS.DEV;
  return ENVIRONMENTS.PROD;
};

export const isLocalhostRuntime = () => {
  const host = window.location.hostname;
  return ['localhost', '127.0.0.1', '[::1]'].includes(host);
};
